/**
 * When ReactEditor.toDOMNode fails for a node that has pageBreaks,
 * the node is stale/orphaned. Remove all its pageBreak entries from
 * the Slate tree so the error doesn't recur on every render cycle.
 *
 * @param {object}   editor   - Slate editor (with removePageBreak from withPageBreaks)
 * @param {Array}    content  - editor.children
 * @param {object}   node     - the Slate node whose pageBreaks are stale
 * @param {Function} removeFn - removePageBreakEntity(editor, content, { pageBreakId })
 */
export function cleanupStalePageBreaks(editor, content, node, removeFn) {
	if (!node || !node.pageBreaks || !Array.isArray(node.pageBreaks)) return;
	const idsToRemove = node.pageBreaks.map(pb => pb.id);
	for (const id of idsToRemove) {
		removeFn(editor, content, { pageBreakId: id });
	}
}
